<template>
    <div>
        <div class="partition-title">{{ partitionKey }}</div>
        <template v-if="isFrontEnd">
            <sumTable
                v-if="merge && merge.length > 0"
                :style="config.width ? ('width:' + config.width + 'px') : ''"
                :row="row"
                :column="column"
                :isSummary="isSummary"
                :tableData="getKList(partitionKey)"
                :mergeTable="mergeTable"
                :merge="merge"
                :config="config"
                :total="total"
                :totalPage="totalPage"
                :page="page"
                :lineClamp="lineClamp"
                :overflowTable="overflowTable"
                :titleConfig="titleConfig"
                :valueConfig="valueConfig"
                :rowWidth="rowWidth"
                :summaryObj="summaryObj"
                index="0"
                :isPartition="true"
                @setWidth="setWidth"
                ></sumTable>
        </template>
        <template v-else>
            <sumTable
                v-if="merge && merge.length > 0"
                :isPartition="true"
                :dashboardId="dashboardId"
                :row="row"
                :column="column"
                :summary="summary"
                :topCount="topCount"
                :id="id"
                :isSummary="isSummary"
                :tableData="getKList(partitionKey)"
                :mergeTable="mergeTable"
                :merge="merge"
                :isFrontEnd="isFrontEnd"
                :total="total"
                :totalPage="totalPage"
                :page="page"
                :overflowTable="overflowTable"
                :index="index"
                :user="user"
                :lineClamp="lineClamp"
                :summaryObj="summaryObj"
                :config="config"
                @relevanceFun="relevanceFun"
                @selectedTable="selectedTable"
                @goSearch="goSearch"
                @rSetReviseRow="rSetReviseRow"
                :reviseObj="reviseObj"
                :saveRevise="saveRevise"
                :selectRow="selectRow"
                :selectCloum="selectCloum"
                :selectPage="selectPage"
                :titleConfig="titleConfig"
                :valueConfig="valueConfig"
                :rowWidth="rowWidth"
            ></sumTable>
        </template>
    </div>
</template>

<script>
    import sumTable from './sumTable.vue'
    export default {
        name: 'partitionCpn',
        components: {
            sumTable
        },
        props: {
            partitionKey: {
                type: String,
                default: ''
            },
            id: {
                type: Number,
                default: 0
            },
            isSummary: {
                type: Number,
                default: 2
            },
            tableData: {
                type: Array || Object,
                default: []
            },
            mergeTable: {
                type: Array,
                default: () => []
            },
            merge: {
                type: Array,
                default: () => { return [] }
            },
            overflowTable: {
                type: Object,
                default: () => { return { x: false,  y: false } }
            },
            index: {
                type: String || Number
            },
            isFrontEnd: {
                type: Boolean,
                default: false
            },
            totalPage: {
                type: Number
            },
            page: {
                type: Number
            },
            total: {
                type: Number,
                default: 0
            },
            row: {
                type: Array,
                default: ()=>[]
            },
            column:{
                type: Array,
                default: ()=>[]
            },
            summary:{
                type: Array,
                default: ()=>[]
            },
            topCount: {
                type: Number,
                default: ()=> 0
            },
            selectRow: {
                type: Number,
                default: ()=>null
            },
            selectCloum: {
                type: Number,
                default: ()=>null
            },
            selectPage: {
                type: Number,
                default: ()=>1
            },
            // 放联系人的
            user: {
                type: Array,
                default: () => []
            },
            lineClamp: {
                type: Number,
                default: 1
            },
            // 表头配置
            titleConfig: {
                type: Object,
                default: () => {}
            },
            // 值配置
            valueConfig: {
                type: Object,
                default: () => {}
            },
            rowWidth: {
                type: Object,
                default: () => {}
            },
            summaryObj: {
                type: Object,
                default: () => {}
            },
            config: {
                type: Object,
                default: () => {}
            },
            reviseObj: {
                type: Object,
                default: () => {}
            },
            dashboardId: String,
            saveRevise: Boolean,
        },
        data () {
            return {}
        },
        methods: {
            setWidth (config) {
                this.$emit('setWidth', config)
            },
            getKList (key) {
                const kk = this.row[0].name
                const arr = this.tableData.filter(it => it[kk] === key)
                return arr
            },
            relevanceFun (config) {
                this.$emit('relevanceFun', config)
            },
            selectedTable (config) {
                this.$emit('selectedTable', config)
            },
            goSearch (config) {
                this.$emit('goSearch', config)
            },
            rSetReviseRow (config) {
                this.$emit('rSetReviseRow', config)
            }
        }
    }
</script>

<style scoped lang="scss">
    .partition-title {
        color: #333333;
        font-weight: 600;
        font-size: 16px;
        line-height: 40px;
        padding-left: 13px;
        position: relative;
        &::before {
            width: 4px;
            height: 18px;
            background-color: #244EBB;
            content: " ";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
</style>
